<template lang="pug">
  nav.fixed.z-30.top-0.left-0.mt-20.md-mt-24.text-11.md-text-13.leading-lg(:class="[`text-${ui}`]")
    router-link.pl-8.pointer-events-auto.flex.items-center(v-if="isLibrary", :to="{name: 'page', params: {slug: 'library'}}")
      icon-arrow.flip.mr-8
      | Library
    .pl-34.pointer-events-auto.flex(v-else)
      template(v-for="(itm, i) in items")
        template(v-if="itm.rt")
          router-link.hover-text-app-text.trans-color-fast(:to="itm.rt", v-html="itm.txt")
        template(v-else)
          span(v-html="itm.txt")
        .icon-chevron.inline-block.mx-8.flex.items-center(v-if="i < items.length - 1")
</template>

<script>
import { mapState } from 'vuex'
import IconArrow from '@/components/Icons/Arrow'
export default {
  name: 'BreadcrumbNav',
  props: ['items', 'isLibrary'],
  computed: {
    ...mapState(['ui'])
  },
  components: { IconArrow }
}
</script>

<style>
.icon-chevron{
  &:after{
    content:'';
    display: block;
    width:.5em;
    height:.5em;
    border-top:1px solid currentColor;
    border-right: 1px solid currentColor;
    transform-origin: center center;
    transform: rotate(45deg) translate(-30%,10%);
  }
}
</style>
